<template>
  <div class="checkbaselayout" id="container">
    <v-check-module
      :title="pagetitle"
      :padding-top="false"
      v-if="pagetitle"
    ></v-check-module>
    <slot></slot>
    <v-check-module
      :title="`申请信息`"
      v-if="checkInfoData"
    >
      <div :class="{'pb20':showMark}">
        <el-row>
          <el-col :span="8">
            <div class="">申请人：{{checkInfoData.createUser | isNoData}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">申请时间：{{checkInfoData.createDate | formatData}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">所属部门：{{checkInfoData.orgName | isNoData}}</div>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <slot name="beforeRemark"></slot>
        <el-col :span="16" v-if="showMark">
          <div class="">备注：{{checkInfoData.mark | isNoData}}</div>
        </el-col>
      </el-row>
    </v-check-module>
    <slot name="checkFooter"></slot>
  </div>
</template>

<script>
import vCheckModule from '@/components/checkLayout/module/checkModule'
export default {
  name: 'checkBaseLayout',
  props: {
    pagetitle: {
      type: String,
      default: ''
    },
    checkInfoData: {
      type: Object,
      default: () => {}
    },
    showMark: {
      type: Boolean,
      default: true
    }
  },
  components: {
    vCheckModule
  }
}
</script>

<style scoped>

</style>
